import React from "react"
import { Container } from "reactstrap"
import Header from '../components/Headers/Header'
import TotalExecutionsChart from '../components/TotalExecutionsChart'
import { useGetExecutionsReport } from '../hooks/useGetExecutionsReport';

const Reports: React.FC = () => {
  const { data, isLoading } = useGetExecutionsReport()

  return (
    <>
      <Header type="inf" />
      <Container className="mt--7" fluid>
        <TotalExecutionsChart
          title="Executions"
          data={data ? data.execsByDate : undefined}
          isLoading={isLoading}
        />
        {/* <TopUnbilledChart />
        <AgingChart /> */}
        <div className="my-4" />
        <TotalExecutionsChart
          title="Questions"
          data={data ? data.quesByDate : undefined}
          isLoading={isLoading}
        />
        <div className="my-4" />
      </Container>
    </>
  )
}

export default Reports
